/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserRegistration { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    reasonForSignUp?: string;
    companyInfo?: string;
    salutation?: string;
    emailVerified?: boolean;
    approvalStatus?: UserRegistration.ApprovalStatusEnum;
}
export namespace UserRegistration {
    export type ApprovalStatusEnum = 'pending' | 'approved' | 'rejected';
    export const ApprovalStatusEnum = {
        Pending: 'pending' as ApprovalStatusEnum,
        Approved: 'approved' as ApprovalStatusEnum,
        Rejected: 'rejected' as ApprovalStatusEnum
    };
}


